export default __webpack_public_path__ + "static/media/home-interior-design-about-img01.b335b6e5.jpg";